module.exports = __webpack_public_path__ + "img/modelIcon_gs.b3d7c88e.png";